module.exports = __webpack_public_path__ + "img/ILEK.1e1d665c.png";